// extracted by mini-css-extract-plugin
module.exports = {"section":"OtherOffers_section__dwHgS","box":"OtherOffers_box__dTtzX","button":"OtherOffers_button__09AWi"};